// Reusable social media types enum and helpers

export const SOCIAL_MEDIA_TYPES = [
  'whatsapp',
  'wechat',
  'tiktok',
  'sinaweibo',
  'redbook',
  'instagram',
  'facebook',
  'youtube',
  'tencent',
];

export const socialTypeLabel = (type) => {
  const key = String(type || '').toLowerCase();
  switch (key) {
    case 'whatsapp': return 'WhatsApp';
    case 'wechat': return '微信';
    case 'tiktok': return 'TikTok';
    case 'sinaweibo': return '新浪微博';
    case 'redbook':
    case 'xiaohongshu':
      return '小紅書';
    case 'instagram': return 'Instagram';
    case 'facebook': return 'Facebook';
    case 'youtube': return 'YouTube';
    case 'tencent': return '騰訊';
    default: return type || '';
  }
};

export const SOCIAL_MEDIA_OPTIONS = SOCIAL_MEDIA_TYPES.map((t) => ({
  value: t,
  label: socialTypeLabel(t),
}));
